import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { TrustStrip } from "@/components/TrustStrip";
import { Services } from "@/components/Services";
import { Jobs } from "@/components/Jobs";
import { Intercity } from "@/components/Intercity";
import { ServiceAreas } from "@/components/ServiceAreas";
import { WhyUs } from "@/components/WhyUs";
import { ContactCta } from "@/components/ContactCta";
import { ContactMap } from "@/components/ContactMap";
import { Footer } from "@/components/Footer";
import { MobileCtaBar } from "@/components/MobileCtaBar";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <Services />
        <Jobs />
        <Intercity />
        <ServiceAreas />
        <WhyUs />
        <ContactCta />
        <ContactMap />
      </main>
      <Footer />
      <MobileCtaBar />
    </div>
  );
}
